import { AnalyticsPlugin } from 'analytics';

import { CONSENT_MANAGER_PLUGIN_NAME } from '../constants/consentManagerPluginName';

// module state rather than store state: the analytics instance is created while the bundle
// loads, and importing useCookieStore here would load useAnalyticStore before `analytics` exists
let resolveConsentManagerLoaded: () => void;

const consentManagerLoaded = new Promise<void>((resolve): void => {
  resolveConsentManagerLoaded = resolve;
});

export const releaseConsentManager = (): void => {
  resolveConsentManagerLoaded();
};

// holds every other analytics plugin, Google Tag Manager and the tracking
// pixels included, until the consent manager has loaded. Running first lets
// the consent manager block their scripts by category, and set Google's
// consent defaults before Google Tag Manager starts. @analytics awaits a
// plugin's initializeStart and trackStart hooks before any plugin's initialize
// and track, so events wait here instead of being dropped. It must stay first
// in createAnalyticsInstance, and calls sent with `plugins: { all: false }`
// must list it (see toTrackOptions), or the hold is skipped. Released on load
// or error alike, so a consent manager that fails to load never holds back the
// page's analytics
export const consentManagerPlugin = (
  loaded: Promise<void> = consentManagerLoaded,
): AnalyticsPlugin => ({
  initializeStart: (): Promise<void> => loaded,
  name: CONSENT_MANAGER_PLUGIN_NAME,
  trackStart: (): Promise<void> => loaded,
});
